<template>
  <div>
    <NavbarView :rainbow="false" />

    <!-- BACK BUTTON -->
    <button class="back-button" @click="$router.back()">
      ← Back
    </button>

    <h1>OTHER PROJECTS</h1>

    <div v-if="items.length">
      <div class="td-grid">
        <div
          v-for="item in items"
          :key="item.id"
          class="td-card-wrapper"
        >
          <!-- TITLE -->
          <div class="td-title">{{ item.title }}</div>

          <!-- MEDIA -->
          <a
            v-if="item.youtube_url"
            :href="item.youtube_url"
            target="_blank"
            rel="noopener noreferrer"
            class="media-link"
          >
            <img
              v-if="item.type === 'image' && item.url_content"
              :src="item.url_content"
              :alt="item.title"
            />
            <video
              v-else-if="item.type === 'video' && item.url_content"
              :src="item.url_content"
              muted
              autoplay
              loop
              playsinline
            />
            <div v-else class="placeholder">No preview</div>
          </a>

          <div v-else class="media-link">
            <img
              v-if="item.type === 'image' && item.url_content"
              :src="item.url_content"
              :alt="item.title"
            />
            <video
              v-else-if="item.type === 'video' && item.url_content"
              :src="item.url_content"
              muted
              autoplay
              loop
              playsinline
            />
            <div v-else class="placeholder">No preview</div>
          </div>

          <!-- ICONS -->
          <div class="td-icons">
            <!-- YouTube -->
            <a
              v-if="item.youtube_url"
              :href="item.youtube_url"
              target="_blank"
              rel="noopener noreferrer"
              title="Watch on YouTube"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/youtube.svg"
                alt="YouTube"
              />
            </a>

            <!-- GitLab -->
            <a
              v-if="item.url_project"
              :href="item.url_project"
              target="_blank"
              rel="noopener noreferrer"
              title="View project files"
            >
              <img
                src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/gitlab.svg"
                alt="GitLab"
              />
            </a>

            <!-- TouchDesigner file -->
            <a
              v-if="item.file"
              :href="item.file"
              target="_blank"
              rel="noopener noreferrer"
              title="Download TouchDesigner file"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/1/1b/Derivative_TouchDesigner_logo.svg"
                alt="TouchDesigner"
              />
            </a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>



<script>
import NavbarView from '../../NavbarView.vue';

export default {
  name: 'OtherProjectsView',
  components: { NavbarView },

  data() {
    return {
      items: [],
    };
  },

  mounted() {
    fetch('https://tommella-general-storage-83d44de1134b.herokuapp.com/apps/td/other/')
      .then(res => res.json())
      .then(data => {
        this.items = data;
      })
      .catch(err => {
        console.error('Fetch failed:', err);
      });
  },
};
</script>



<style scoped>
h1 {
  text-align: center;
  margin: 100px 0 30px;
  font-size: 2.5em;
  color: #176219;
}

.td-title {
  margin: 18px 0;
  font-weight: 700;
  font-size: 1.5rem;
  text-align: center;
}

.td-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 60px 60px;
}

.media-link,
.placeholder {
  width: 100%;
  aspect-ratio: 1280 / 720;
  border-radius: 10px;
  overflow: hidden;
  display: block;
}

.media-link img,
.media-link video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #111;
  color: white;
}

/* ICONS */
.td-icons {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 10px;
}

.td-icons img {
  width: 18px;
  height: 18px;
  opacity: 0.6;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.td-icons img:hover {
  opacity: 1;
  transform: scale(1.1);
}

/* BACK BUTTON */
.back-button {
  position: fixed;
  top: 90px;
  left: 30px;
  background: #eee;
  border: none;
  color: #333;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 0.9rem;
  cursor: pointer;
  z-index: 10;
}

.back-button:hover {
  background: #ddd;
}
</style>
